define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/table/matrix/Path",
	"csi/xml"
], function(declare,_,PathMatrix,xml) {

	var	PATH_SAMPLE_DIMENSIONS_FIRST = "Child:ReviewSize/Child:ReviewSizeSamples/Index:0/Child:Dimensions";

	var	MATRIX_GAPS = {
		SizeChartReviewActualGap: 1,
		SizeChartReviewSewnGarmentActualGap: 1
	};

	return declare(PathMatrix, {
		columnPath: "Child:Review/Child:ReviewSizes/Child:ReviewSizeSamples",

		addDependencyPaths: function(/*Heading*/h, /*String[]*/paths) {
			// summary: add any dependency paths necessary to process matrix
			paths.push("Child:Review/Child:ReviewSizes/Child:ReviewSizeSamples/Child:Dimensions");
			this.inherited(arguments);
		},
		
		/**
		 * @override
		 * Set special css class for base size column to highlight base size column
		 */
		getColumnSpecs: function(ctx, h) {
			var specs = this.inherited(arguments);
			
			var cache = ctx.cache;
			var baseSizes = ctx.view.getViewNode().SizeChartSubSizeRanges;
			baseSizes.forEach(function(size){
				var baseSizeUrl = cache.getNode(size).BaseSize;
				specs.forEach(function(spec){
					var specSizeUrl = cache.getNode(spec.columnUrl).ProductSize;
					if (specSizeUrl == baseSizeUrl){
						spec.css += " csi-size-base";
					}
				})
			})
			return specs;
		},
			

		_filterNodes: function(/*Context*/ctx, /*Spec*/spec, /*Node[]*/nodes) {
			// summary: apply any filters
			var	columnUrl = spec.columnUrl;
			return _.filter(nodes, function(node) {
				return ctx.cache.getNode(node.ReviewSize).ReviewSizeSamples.indexOf(columnUrl) >= 0;
			});
		},

		_getColumnNodes: function(/*Context*/ctx, /*Heading*/h) {
			// summary: return array of nodes to be shown as columns if column matrix - return empty array if column matrix but no results
			var view = ctx.view;
			var sizeUrls =  view.columnNodeUrls;
			var sampleUrls = view.columnNodeSampleUrls;
			if (sampleUrls) {
				// return selected samples
				return ctx.cache.getNodes(sampleUrls);
			}
			
			if (sizeUrls) {
				// return samples for selected sizes
				return ctx.cache.getNodes(ctx.view._getSampleUrlsFromSelectedSizes());
			}
			
			// return all samples
			return this.inherited(arguments);
		},

		_getSpecIndices: function(/*Context*/ctx, /*Spec*/spec, /*Node[]*/nodes) {
			// summary: doublevector attributes and gaps involving those attributes will use index of sample in size's samples vector
			console.assert(nodes.length == 1);

			if ((spec.type == xml.ATTR_DOUBLEVECTOR) || (MATRIX_GAPS[spec.heading.m_nameOrig])) {
				var	size = ctx.cache.getNode(ctx.getNode().ReviewSize);
				return [size.ReviewSizeSamples.indexOf(spec.columnUrl)];
			}

			return null;
		},

		_getSpecNodes: function(/*Context*/ctx, /*Spec*/spec, /*Node[]*/nodes) {
			// summary: sample actual specs need to return appropriate SampleDimensions node
			if (spec.heading.m_path == PATH_SAMPLE_DIMENSIONS_FIRST) {
				var	sample = ctx.cache.getNode(spec.columnUrl);
				return [ctx.cache.getNode(sample.Dimensions)];
			}

			return null;
		}
	});
});